<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">RELATORIO DE ABASTECIMENTOS BLOQUEADOS:
            </h3>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(filter.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(filter.endDate = $event)]"
                    label="Data Final"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="filter.prefecture_id"
                    label="Prefeitura"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    clearable
                    :disabled="$store.getters.getUserData.table_key == 'prefectures' ? true : false"
                    @change="getProviders(filter.prefecture_id)"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="filter.provider_id"
                    label="Participante"
                    :items="providers"
                    item-text="provider_name"
                    item-value="provider_id"
                    clearable
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <br />
          <v-footer absolute rounded>
            <v-btn text :loading="loader"></v-btn>
            <v-spacer />
            <v-btn
              color="secondary"
              class="mr-2"
              text
              @click="getData"
              :disabled="
                filter.startDate && filter.endDate && filter.prefecture_id
                  ? false
                  : true
              "
              >FILTRAR</v-btn
            >
          </v-footer>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6" outlined>
          <v-toolbar color="secondary" dark shaped>
            <v-btn text :loading="loader"></v-btn>
            <v-spacer />
            <v-btn
              text
              :disabled="supplies.length > 0 ? false : true"
              target="_blank"
              :to="`/report/master/blocked/${filter.startDate}/${filter.endDate}/${filter.prefecture_id}/${filter.provider_id}`"
              >GERAR RELATÓRIO</v-btn
            >
            <v-btn
              color="white"
              class="mr-2"
              text
              @click="dropSupplies"
              :disabled="selectedSupplies.length > 0 ? false : true"
              v-if="$store.getters.getUserData.table_key == 'prefectures' ? false : true"
              >DELETAR ABASTECIMENTOS
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-data-table
                :items="supplies"
                :headers="headers"
                :loading="loader"
                :show-select="$store.getters.getUserData.table_key == 'prefectures' ? false : true"
                item-key="supply_id"
                v-model="selectedSupplies"
              >
                <template v-slot:item.datehour="{ item }">
                  <span>{{ convertDateTime(item.datehour) }}</span>
                </template>
                <template v-slot:item.supply_liters_stocked="{ item }">
                  <span>{{
                    item.supply_liters_stocked
                      ? realMaskII(item.supply_liters_stocked)
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.item_billing_price="{ item }">
                  <span>{{
                    item.supply_bidding_price
                      ? realMaskII(item.supply_bidding_price)
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.total_billing_price="{ item }">
                  <span>{{
                    item.supply_bidding_price && item.supply_liters_stocked
                      ? realMask(
                          (
                            item.supply_bidding_price *
                            item.supply_liters_stocked
                          ).toFixed(2)
                        )
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.supply_price_day="{ item }">
                  <span>{{
                    item.supply_price_day
                      ? realMaskII(item.supply_price_day)
                      : 0
                  }}</span>
                </template>
                <template v-slot:item.supply_value="{ item }">
                  <span>{{
                    item.supply_value
                      ? realMask(item.supply_value.toFixed(2))
                      : 0
                  }}</span>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-footer class="pa-4">
            <v-label
              >Total Dia:
              {{
                totals.day_value ? realMask(totals.day_value.toFixed(2)) : 0
              }}</v-label
            >
            <v-spacer />
            <v-label
              >Total Liçitado:
              {{
                totals.bidding_total
                  ? realMask(totals.bidding_total.toFixed(2))
                  : 0
              }}</v-label
            >
          </v-footer>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    providers: [],
    items: [],
    selectedSupplies: [],
    filter: {
      prefecture_id: null,
      provider_id: null,
      startDate: null,
      endDate: null,
    },
    totals: {
      bidding_total: 0,
      day_value: 0,
      billing_price: 0,
    },
    supplies: [],
    headers: [
      { text: "Data/Hora", value: "datehour" },
      { text: "Lts Abastecidos", value: "supply_liters_stocked" },
      { text: "Preço Licitado", value: "supply_bidding_price" },
      { text: "T. Licitado", value: "total_billing_price" },
      { text: "Preço do dia", value: "supply_price_day" },
      { text: "Total", value: "supply_value" },
      { text: "Senha", value: "supply_code" },
      { text: "Status", value: "supply_status" },
      { text: "Número do Cupom", value: "supply_coupon" },
      { text: "Motorista", value: "driver_name" },
    ],
    loader: false,
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    if(this.$store.getters.getUserData.table_key == 'prefectures') {
      this.filter.prefecture_id = this.$store.getters.getUserData.table_id
      this.getProviders(this.filter.prefecture_id);
    }
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    getProviders(id) {
      this.$http.get(`/providers/prefecture/${id}`).then((r) => {
        this.providers = r.data;
        this.loader = false;
        this.$store.dispatch("setLoader", this.loader);
      });
    },
    dropSupplies() {
      let c = confirm("Deseja excluir os abastecimentos selecionados?");
      if (c) {
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/supplies/blocked/delete", {
            selectedSupplies: this.selectedSupplies,
          })
          .then((r) => {
            this.snack.message = r.data.result;
            this.loader = false;
            this.getData();
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    getData() {
      if (this.filter.prefecture_id) {
        this.totals.day_value = 0;
        this.totals.bidding_total = 0;
        this.supplies = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        let liters = 0;
        let bidding_price = 0;
        let supply_price_day = 0;
        this.$http
          .post(`/supplies/blocked`, this.filter)
          .then((supplies) => {
            this.supplies = supplies.data;
            supplies.data.map((supply,index) => {
              liters = supply.supply_liters_stocked.toFixed(3);
              bidding_price = supply.supply_bidding_price.toFixed(3);
              supply_price_day = supply.supply_price_day.toFixed(3);
              this.supplies[index].supply_liters_stocked = liters;
              this.supplies[index].supply_bidding_price = bidding_price;
              this.supplies[index].supply_price_day = supply_price_day;
              this.totals.day_value += parseFloat(supply.supply_value);
              this.totals.bidding_total += parseFloat(
                supply.supply_bidding_value
              );
            });
            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
  },
};
</script>

<style>
</style>